import { useContext } from 'react';
import { SizeAndWidthContext } from './sizeAndWidthContext';

export const useSizeAndWidthContext = () => useContext(SizeAndWidthContext);
